import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Check, X, Loader2 } from "lucide-react";
import { adminApi, errMsg } from "@/lib/api";
import { TypeBadge } from "@/components/TypeBadge";

export const DraftsPanel = ({ drafts, reload }) => {
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi().post("/admin/ai-draft");
      toast.success(`${data.created} AI drafts ready for review`);
      reload();
    } catch (e) { toast.error(errMsg(e)); }
    setLoading(false);
  };
  const act = async (id, action) => {
    await adminApi().post(`/admin/drafts/${id}/${action}`);
    toast.success(action === "approve" ? "Published to vault" : "Draft rejected");
    reload();
  };

  return (
    <section className="rounded-2xl bg-[#0F131D] border border-white/10 p-6" data-testid="drafts-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display font-bold text-lg">AI daily drafts</h2>
          <p className="text-xs text-slate-500 mt-1">AI suggestions are based on publicly known offers — verify on the casino site before approving.</p>
        </div>
        <button onClick={generate} disabled={loading} data-testid="admin-ai-draft-btn" className="flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 disabled:opacity-60 text-[#07090E] font-bold px-5 h-10 text-sm transition-colors">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />} Draft today's update
        </button>
      </div>
      <div className="mt-5 space-y-3">
        {drafts.map((d, i) => (
          <div key={d.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-white/5 bg-[#151B28] px-4 py-3" data-testid={`draft-row-${i}`}>
            <TypeBadge type={d.bonus_type} />
            <div className="flex-1 min-w-[200px]">
              <p className="font-semibold text-sm">{d.casino} <span className="font-mono text-amber-300 ml-2">{d.value}</span></p>
              <p className="text-xs text-slate-400">{d.title}</p>
            </div>
            <button onClick={() => act(d.id, "approve")} data-testid={`draft-approve-${i}`} className="h-9 w-9 grid place-items-center rounded-full bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/30"><Check size={16} /></button>
            <button onClick={() => act(d.id, "reject")} data-testid={`draft-reject-${i}`} className="h-9 w-9 grid place-items-center rounded-full bg-red-500/10 text-red-400 hover:bg-red-500/25"><X size={16} /></button>
          </div>
        ))}
        {!drafts.length && <p className="text-sm text-slate-500" data-testid="drafts-empty">No pending drafts.</p>}
      </div>
    </section>
  );
};
